import { createActionConst } from '../../../utils/action.utils';

const SESSION_TRANSCRIPT_PAGE_NAMESPACE = 'SESSION_TRANSCRIPT_PAGE';

export const INITIAL_SESSION_TRANSCRIPT_PAGE = createActionConst(
  SESSION_TRANSCRIPT_PAGE_NAMESPACE,
  'INITIAL_SESSION_TRANSCRIPT_PAGE',
);

export const FETCH_SESSION_TRANSCRIPT = createActionConst(
  SESSION_TRANSCRIPT_PAGE_NAMESPACE,
  'FETCH_SESSION_TRANSCRIPT',
);

export const STORE_SESSION_TRANSCRIPT = createActionConst(
  SESSION_TRANSCRIPT_PAGE_NAMESPACE,
  'STORE_SESSION_TRANSCRIPT',
);
export const CLEAR_SESSION_TRANSCRIPT = createActionConst(
  SESSION_TRANSCRIPT_PAGE_NAMESPACE,
  'CLEAR_SESSION_TRANSCRIPT',
);

export const FETCH_SESSION_TRANSCRIPT_SUMMARY = createActionConst(
  SESSION_TRANSCRIPT_PAGE_NAMESPACE,
  'FETCH_SESSION_TRANSCRIPT_SUMMARY',
);
